document.addEventListener('DOMContentLoaded', () => {
  let cartReady = false

  if (!customElements.get('gift-box-checkbox')) {
    customElements.define('gift-box-checkbox', class GiftBoxCheckbox extends HTMLElement {
      constructor() {
        super()

        this.computeProductInCart()

        this.querySelector('#gift-box-checkbox').addEventListener('click', event => {
          if (!this.giftBoxInCart)
            document.querySelector('gift-box-panel').open(this.querySelector('#tick-text'))
          else {
            this.variantId = Number(this.getAttribute('data-gift-id'))

            CartJS.setNote('')
            if (this.variantId) CartJS.updateItemById(this.variantId, 0)
            this.querySelector('#gift-box-checkbox').classList.add('free-gift-loading')

            this.resetGiftCheck()
          }
        })

        this.querySelectorAll(['#tick-text']).forEach(item => {
          item.addEventListener('click', () => {
            // if (!this.giftBoxInCart)
            document.querySelector('gift-box-panel').open(item)
          })
          // #404: the opener is a span with role="button", so it needs the keys too.
          item.addEventListener('keydown', event => {
            if (event.key !== 'Enter' && event.key !== ' ') return
            event.preventDefault()
            item.click()
          })
        })
      }

      resetGiftCheck() {
        document.querySelector('#add-gift-box-product span').innerHTML = document.querySelector('#add-gift-box-product').getAttribute('data-text')
        document.querySelector('#tick-text').innerHTML = 'Is this a gift? Add a handwritten gift card and gift wrapping to your order.'
        document.querySelector('gift-box-checkbox').classList.remove('activegift')
        document.querySelector('.btn--giftnote').classList.add('disabled')
        $(document).on('cart.requestComplete', this.doUpdate)
      }

      productId = 0
      variantId = 0
      giftBoxInCart = false

      doUpdate() {
        publish(PUB_SUB_EVENTS.cartUpdate, {isAll: true});
        $(document).off('cart.requestComplete', this.doUpdate)
      }

      computeProductInCart() {
        this.productId = Number(this.getAttribute('data-gift-product-id'))
        this.variantId = Number(this.getAttribute('data-gift-id'))

        const cart = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.productId) {

          for (const item of cart.items) {
            if (item.product_id === this.productId) {
              this.giftBoxInCart = true
            }
          }

        } else  {
          this.giftBoxInCart = !!cart.note
        }

        if (this.giftBoxInCart) {
          this.classList.add('activegift')
        }

        // if (cart.items.length) {
        //   this.style.display = 'block'
        // } else {
        //   this.style.display = 'none'
        // }
      }
    })
  }

  if (!customElements.get('gift-box-panel')) {
    customElements.define('gift-box-panel', class GiftBoxPanel extends HTMLElement {
      constructor() {
        super()
        this.productId = Number(this.getAttribute('data-gift-product-id'))
        this.variantId = Number(this.getAttribute('data-gift-id'))

        setTimeout(() => {
          this.style.display = "flex"
        }, 500);

        const cartJson = JSON.parse(this.querySelector('#cart-json').innerHTML)
        this.computeProductInCart(cartJson)

        this.querySelectorAll(['.mini-cart-giftnote__top--icon', '.btn--giftnote--cancel']).forEach(item => item.addEventListener('click', () => {
          this.close()
        }))

        // #404: the close, add and cancel controls are links with role="button".
        // Enter and Space press them, and Escape closes the panel, not the drawer.
        this.addEventListener('keydown', event => {
          if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[role="button"]')) {
            event.preventDefault()
            event.target.click()
          }
        })
        this.addEventListener('keyup', event => {
          if (event.code !== 'Escape' || !this.classList.contains('is-open')) return
          event.stopPropagation()
          this.close()
        })

        this.defaultText = document.querySelector('#add-gift-box-product span').innerHTML

        document.querySelector('#gift-note').addEventListener('keydown', () => {
          if (document.querySelector('#gift-note').value)
            document.querySelector('.btn--giftnote').classList.remove('disabled')
          else
            document.querySelector('.btn--giftnote').classList.add('disabled')
        })

        this.querySelector('#add-gift-box-product').addEventListener('click', (event) => {
          if (event.target.classList.contains('disabled')) {
            return
          }

          if (!this.giftBoxInCart) {
            if (this.variantId) CartJS.addItem(this.variantId)
            this.giftBoxInCart = true
          }
          CartJS.setNote(this.querySelector('#gift-note').value)
          event.target.classList.add('free-gift-loading')
          $(document).on('cart.requestComplete', this.updateStatus.bind(this))
        })
      }

      // #404: closed, the panel sits off screen to the right, but its controls
      // could still take focus, and the browser scrolled the page sideways to
      // show them. inert keeps a closed panel out of the Tab order and away from
      // screen readers.
      connectedCallback() {
        this.inert = !this.classList.contains('is-open')
      }

      // Opens the panel and moves the drawer's focus trap into it. `opener`
      // gets focus back when the panel closes.
      open(opener) {
        this.opener = opener
        this.inert = false
        this.classList.add('is-open')
        if (typeof trapFocus === 'function') trapFocus(this, this.querySelector('#gift-note'))
      }

      // Closes the panel and hands the focus trap back to the open drawer.
      close() {
        this.classList.remove('is-open')
        this.inert = true
        const drawer = document.querySelector('cart-drawer.active .cart-drawer__inner')
        if (drawer && typeof trapFocus === 'function') {
          trapFocus(drawer, this.opener && this.opener.isConnected ? this.opener : drawer)
        }
      }

      updateStatus() {
        this.close()
        document.querySelector('#add-gift-box-product span').innerHTML = "UPDATE"
        this.querySelector('#add-gift-box-product').classList.remove('free-gift-loading')
        // if (this.giftBoxInCart) {
          publish(PUB_SUB_EVENTS.cartUpdate, {});
        // }

        $(document).off('cart.requestComplete', this.updateStatus)
      }

      productId = 0
      variantId = 0
      defaultText = ''
      giftBoxInCart = false

      computeProductInCart(cart) {
        if (cart.note) {
          this.classList.add('activegift')
          this.giftBoxInCart = true
        }

        if (this.giftBoxInCart && cart.note) {
          document.querySelector('#gift-note').value = cart.note || ''

          document.querySelector('#add-gift-box-product span').innerHTML = "UPDATE"
          if (cart.note)
            document.querySelector('.btn--giftnote').classList.remove('disabled')
        } else {
          document.querySelector('#gift-note').value = ''
        }

        const rate = Number(window.Shopify.currency.rate)
        const giftBoxAmount = Number(this.getAttribute('data-free-amount')) * rate
        
        if (cart.total_price >= giftBoxAmount) {
          document.querySelector('#add-gift-box-product span').innerHTML = this.giftBoxInCart && cart.note ? "UPDATE" : 'ADD FOR FREE'
        } 
      }
    })
  }


})
